import { createInertiaApp } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { resolvePageComponent } from './helpers';
import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact, { BugsnagErrorBoundary } from '@bugsnag/plugin-react';
import React from 'react';

const bugsnagAPIKey = import.meta.env.VITE_FRONTEND_BUGSNAG_API_KEY as string | null || '';

if (bugsnagAPIKey) {
    Bugsnag.start({
        apiKey: bugsnagAPIKey,
        plugins: [new BugsnagPluginReact()],
    });
    BugsnagPerformance.start({ apiKey: bugsnagAPIKey });
}

const FallbackErrorBoundary: BugsnagErrorBoundary = ({ children }) => {
    return <>{children}</>;
};
const ErrorBoundary = Bugsnag.isStarted() ? Bugsnag.getPlugin('react')?.createErrorBoundary(React) ?? FallbackErrorBoundary : FallbackErrorBoundary;


void createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        if (process.env.NODE_ENV === 'development') {
            createRoot(el).render(<ErrorBoundary><App {...props} /></ErrorBoundary>);
        } else {
            hydrateRoot(el, <ErrorBoundary><App {...props} /></ErrorBoundary>);
        }
    },
    defaults: {
        future: {
            useScriptElementForInitialPage: import.meta.env.VITE_USE_SCRIPT_TAG === 'true' ? true : false,
        },
    },
});
